import styled from 'styled-components'
import helpGif from 'assets/new-tools-menu.gif'
import Tooltip from 'components/Tooltip'

export const ToolsMenuContainer = styled.div`
  position: fixed;
  z-index: 0;
  top: 0;
  right: 0;

  .popoverGroup {
    display: flex;

    position: absolute;
    top: 35vh;
  }

  .infoPopoverOverlay {
    position: fixed;
    top: 0;
    right: 0;

    width: 100vw;
    height: 100vh;

    background: rgba(51, 51, 51, 0.72);
  }

  .infoPopoverContainer {
    position: absolute;
    right: 100%;
  }

  .infoPopoverPanel {
    position: relative;

    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.5rem;

    width: 16rem;
    max-width: 20rem;

    padding: 1rem;

    border: 1px solid ${({ theme }) => `rgb(${theme.component.accent})`};
    border-radius: 0.5rem;

    background: ${({ theme }) => `rgb(${theme.background.high})`};

    transform: translate(-12px, -170px);

    @media screen and (min-width: 320px) {
      width: 18rem;
      transform: translate(-12px, -160px);
    }

    @media screen and (min-width: 360px) {
      width: 20rem;
      transform: translate(-12px, -150px);
    }

    @media screen and (min-width: 800px) {
      transform: translate(-130px, -89px);
    }

    &::before {
      content: '';

      position: absolute;
      right: 10%;
      bottom: -6px;
      transform: rotateZ(45deg);

      width: 12px;
      height: 12px;

      background: ${({ theme }) => `rgb(${theme.background.high})`};

      @media screen and (min-width: 800px) {
        right: -6px;
        top: 30%;
      }
    }

    .closeButton {
      display: none;

      font-weight: 700;
      font-size: 1rem;
      color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
    }

    .helpImage {
      margin: 0;

      width: 100%;
    }

    @media screen and (min-width: 800px) {
      .closeButton {
        display: initial;
      }

      .helpImage {
        border: 1px solid ${({ theme }) => `rgb(${theme.component.accent})`};
        background-image: url(${helpGif});
        background-size: cover;
        width: 100%;
        height: 229px;
      }
    }

    p {
      margin: 0;
      font-size: 0.75rem;
    }

    .infoText {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      p:nth-child(1) {
        font-weight: 600;
        color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
      }

      p:nth-child(2) {
        font-weight: 400;
        color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
      }

      .mainText {
        display: flex;
        justify-content: space-between;

        button {
          color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
        }

        @media screen and (min-width: 800px) {
          button {
            display: none;
          }
        }
      }
    }

    .finishButton {
      font-size: 0.75rem;
      font-weight: 500;
      color: ${({ theme }) => `rgb(${theme.primary.base})`};
    }
  }

  .popoverContainer {
    position: absolute;
    left: -3.3125rem;

    height: 50%;
    z-index: 2;

    display: flex;
    align-items: flex-start;
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;

    background-color: transparent;
    border: none;
    outline: none;
  }

  .popoverButton {
    position: fixed;
    right: 0;
    z-index: -1;

    background: ${({ theme }) => `rgb(${theme.background.low})`};
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};

    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.25);

    padding: 1.125rem 0.875rem;
    border-radius: 0.5rem;
  }

  .popoverButton {
    &.open {
      transform: translateX(-53px);
    }

    &.close {
      transform: translateX(40%);
    }

    svg {
      width: 1.75rem;
      height: 1.75rem;
    }
  }

  .actionsWrapper {
    position: relative;
    z-index: 1;

    display: flex;
    flex-direction: column;

    width: 53px;

    background: ${({ theme }) => `rgb(${theme.background.low})`};

    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.25);
    border-radius: 0.5rem;
  }

  .actionsWrapper button {
    padding: 1rem;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};

    a:hover {
      color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
    }
  }

  .actionsWrapper svg {
    width: 1.3rem;
    height: 1.3rem;
  }

  /* Animation Classes */

  .transition {
    transition: all;
    transition-duration: 0.3s;
    transition-timing-function: ease;
  }

  .enterFrom {
    transform: translateX(100%);
    opacity: 0;
  }

  .enterTo {
    transform: translateX(0);
    opacity: 1;
  }

  .leaveFrom {
    transform: translateX(0);
  }

  .leaveTo {
    transform: translateX(100%);
  }
`

export const ToolsMenuTooltip = styled(Tooltip)`
  span {
    position: absolute;
    left: initial;
    bottom: initial;

    top: 25%;
    right: 0;

    background: ${({ theme }) => `rgb(${theme.component.accent})`};
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

    font-size: 12px;

    &::before {
      all: unset;

      content: '';

      position: absolute;
      right: -4px;
      top: 50%;

      transform: translateY(-50%) rotateZ(45deg);

      background: ${({ theme }) => `rgb(${theme.component.accent})`};

      width: 8px;
      height: 8px;
    }
  }
`
